import { Role } from "../types/role.enum";

export const roles: { id: Role; name: Role }[] = [
  { id: Role.OPERATOR, name: Role.OPERATOR },
  { id: Role.OWNER, name: Role.OWNER },
  { id: Role.SUPERVISOR, name: Role.SUPERVISOR },
  { id: Role.CUSTOMER, name: Role.CUSTOMER },
];
